import React, { useContext, useMemo } from 'react';
import { TickIconGrey, TickIcon, LottoWinnings } from 'src/assets/images';
import { HelpButton, ScrollTop, SolutionType } from 'src/features/common';
import { Carousel } from 'src/features/order/components';
import { ApplicationContext } from '../../context';
import { getOnboardingCompleteHeadings } from 'src/features/onboarding/helpers/headings';
import { CardType } from '../../pages/setup-completion/setup-completion';
import { PAGE_NAME } from 'src/features/common/types/tealium-service';
import './onboarding-complete.scss';

interface Props {
  cards: CardType[];
}

export const OnboardingComplete = ({ cards }: Props) => {
  const { application, onboardingTealiumService } = useContext(ApplicationContext);

  const headings = useMemo(
    () =>
      getOnboardingCompleteHeadings(application.solutionType === SolutionType.thirdPartyOnboarding),
    [application.solutionType],
  );

  return (
    <article className="setup-completion-container">
      <ScrollTop />
      <section className="completion-message-container">
        <section className="row-box is-hidden-mobile">
          <section>
            <h1>{headings.main}</h1>
            <p>{headings.second}</p>
            <p>{headings.third}</p>

            <p className="catch-phrase">We're on this journey with you... Sinawe. </p>
          </section>
          <img src={LottoWinnings} alt="Congratulations" />
        </section>

        <section className="row-box is-hidden-tablet">
          <h1>{headings.main}</h1>
          <img src={LottoWinnings} alt="Congratulations" />

          {application.tapOnPhoneJourney ? (
            <ol className="text-left list-decimal">
              <li>{headings.second}</li>
              <li>
                <strong>Please close the app</strong> and check your email and SMS for the next
                steps
              </li>
            </ol>
          ) : (
            <ul>
              <li>{headings.second}</li>
              <li>{headings.third}</li>
            </ul>
          )}

          <p className="catch-phrase">
            We're on this journey with you... <br /> Sinawe.
          </p>
        </section>
        <hr />

        <h2>What happens next</h2>
      </section>
      <Carousel>
        {cards.map(({ title, content, completed }, index) => (
          <section
            key={`setup-complete-card-${index}`}
            className={`single-card ${completed ? 'highlighted' : ''}`}
          >
            <div>
              <img src={completed ? TickIcon : TickIconGrey} alt="Tick Icon" />
              <h5>{title}</h5>
            </div>
            <p>{content}</p>
          </section>
        ))}
      </Carousel>
      <HelpButton
        onOpen={() =>
          onboardingTealiumService.onHelpButtonActions(PAGE_NAME.SETUP_COMPLETION, 'help')
        }
        onEmailClicked={() =>
          onboardingTealiumService.onHelpButtonActions(PAGE_NAME.SETUP_COMPLETION, 'email support')
        }
        onPhoneNumberClicked={() =>
          onboardingTealiumService.onHelpButtonActions(
            PAGE_NAME.SETUP_COMPLETION,
            'call support number',
          )
        }
      />
    </article>
  );
};
